/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query PhoneNumberoDirectoryReadUniqueQuery($phoneNumberoDirectoryId: ID!) {
  PhoneNumberoDirectoryReadUnique(phoneNumberoDirectoryId: $phoneNumberoDirectoryId) {
    id,
    displayName,
    message,
    status
  }
}
`
